import "./ArchiveProductTemplate.module.css"
import Header from "@/reusable_sections/Header"
import ArchiveTitleSection from "./sections/ArchiveTitleSection"
import Catalog from "./sections/Catalog"
import Footer from "@/reusable_sections/Footer"

export default function ArchiveProductTemplatePage() {

  return (
    <div>
      <Header />
      <ArchiveTitleSection />
      <Catalog />
      <Footer />
    </div>
  )
}
